import CustomButton from '@/components/custom-button/custom-button';
import { useNavigate } from 'react-router-dom';
import AvocadoLogo from '@/assets/avocado-logo/avocado-logo';
import { useTheme } from '@/contexts/theme-context/useThemeContext';
import { LegalDocumentFormat, LegalDocumentHeader, LegalDocumentLayout } from './style-component';
import { useEffect, useRef } from 'react';
import { amplitudeAddTrack, determineProjectName } from '@/utils/amplitud/event-track';
import SEOHelmet from '@/components/SEOHelmet/SEOHelmet';
const PrivacyPolicyPage: React.FC = () => {

  const navigate = useNavigate();

  const handleBack = () => {
    if (window.history.state && window.history.state.idx > 0) {
      navigate(-1);
    } else {
      navigate('/home');
    }
  };

  const theme = useTheme();
  const isDarkMode = theme?.theme?.name === 'dark';

  const firstRenderAmplitude = useRef<boolean>(true);
  useEffect(() => {
    if (firstRenderAmplitude.current) {
      firstRenderAmplitude.current = false;
      amplitudeAddTrack(determineProjectName(`Política de Privacidad`), {
        title: determineProjectName(`Política de Privacidad`),
      })
    }
  }, []);

  return (
    <LegalDocumentLayout>
      <SEOHelmet
        metadata={{
          title: determineProjectName(`Política de Privacidad`),
          description: determineProjectName(`Política de Privacidad`)
        }}
      />
      <LegalDocumentHeader>
        <AvocadoLogo width={320} color={isDarkMode ? "#FFFFFF" : "#000000"} />
        <h1 id="-pol-tica-de-privacidad-y-de-protecci-n-de-datos-personales-"><strong>Política de Privacidad y Protección de Datos Personales</strong></h1>
      </LegalDocumentHeader>
      <LegalDocumentFormat>
        <h1 id="-aviso-de-privacidad-"><strong>AVISO DE PRIVACIDAD</strong></h1>
        <p><strong>Última actualización:</strong> 15 de octubre de 2025</p>
        <h2 id="-1-identidad-y-domicilio-del-responsable-"><strong>1. IDENTIDAD Y DOMICILIO DEL RESPONSABLE</strong></h2>
        <p>Avocado Blockchain Services (en adelante &quot;ABS&quot;), con domicilio en [DIRECCIÓN COMPLETA], es responsable del tratamiento y protección de sus datos personales.</p>
        <h2 id="-2-datos-personales-que-recabamos-"><strong>2. DATOS PERSONALES QUE RECABAMOS</strong></h2>
        <p>Para proporcionar nuestros servicios de software SaaS de lealtad, recopilamos los siguientes tipos de datos:</p>
        <h3 id="-2-1-datos-de-identificaci-n-y-contacto-"><strong>2.1 Datos de identificación y contacto:</strong></h3>
        <ul>
          <li>Direcciones de correo electrónico: utilizadas para la creación de cuentas, inicio de sesión, atención al cliente y comunicaciones de marketing  </li>
          <li>Direcciones IP: recopiladas para mantener la seguridad e integridad de nuestros servicios</li>
        </ul>
        <h3 id="-2-2-datos-blockchain-y-transaccionales-"><strong>2.2 Datos blockchain y transaccionales:</strong></h3>
        <ul>
          <li>Detalles de la transacción: registrados en la cadena de bloques, incluyendo claves públicas asociadas con transacciones  </li>
          <li>Claves públicas: generadas en función del inicio de sesión social del usuario a través de magic.link, Web3Auth o Crossmint para el procesamiento de transacciones</li>
        </ul>
        <h3 id="-2-2-datos-blockchain-y-transaccionales-"><strong>2.3 Otros datos:</strong></h3>
        <ul>
          <li>Datos derivados de interacciones en redes sociales: Contenido público en plataformas digitales. </li>
          <li>Cuando el Usuario participa voluntariamente en campañas promocionales que involucran redes sociales, nuestra plataforma podrá acceder, recopilar, procesar y almacenar las publicaciones de carácter público realizadas por el Usuario en dichas plataformas</li>
          <li>No obstante el carácter público de dichos contenidos, al aceptar la presente Política de Privacidad, el Usuario otorga su consentimiento expreso e inequívoco para que la Compañía pueda acceder a los mencionados contenidos, analizarlos y utilizarlos conforme a las finalidades especificadas en la presente política, respetando en todo momento los derechos fundamentales del Usuario y la normativa aplicable en materia de protección de datos personales</li>
        </ul>
        <h3 id="-2-3-m-todos-de-recopilaci-n-"><strong>2.4 Métodos de recopilación:</strong></h3>
        <p>Los datos se recopilan directamente de los usuarios durante:</p>
        <ul>
          <li>La configuración de la cuenta  </li>
          <li>Los procesos transaccionales  </li>
          <li>Las interacciones con la plataforma</li>
        </ul>
        <h2 id="-3-finalidades-del-tratamiento-de-datos-"><strong>3. FINALIDADES DEL TRATAMIENTO DE DATOS</strong></h2>
        <h3 id="-3-1-finalidades-primarias-"><strong>3.1 Finalidades primarias:</strong></h3>
        <ul>
          <li>Creación de cuenta e inicio de sesión mediante direcciones de correo electrónico  </li>
          <li>Procesamiento de transacciones utilizando claves públicas en la cadena de bloques  </li>
          <li>Mantenimiento de la seguridad e integridad del servicio  </li>
          <li>Atención al cliente  </li>
          <li>Cumplimiento de obligaciones contractuales</li>
        </ul>
        <h3 id="-3-2-finalidades-secundarias-"><strong>3.2 Finalidades secundarias:</strong></h3>
        <ul>
          <li>Marketing promocional (sujeto al consentimiento del usuario al registrarse)  </li>
          <li>Mejora de nuestros servicios  </li>
          <li>Análisis estadísticos</li>
        </ul>
        <h2 id="-4-base-legal-y-consentimiento-"><strong>4. BASE LEGAL Y CONSENTIMIENTO</strong></h2>
        <h3 id="-4-1-base-legal-para-el-tratamiento-"><strong>4.1 Base Legal para el Tratamiento:</strong></h3>
        <p>El procesamiento de datos se fundamenta en:</p>
        <ul>
          <li>El consentimiento explícito del usuario  </li>
          <li>La necesidad de ejecutar un contrato con el usuario  </li>
          <li>El cumplimiento de obligaciones legales  </li>
          <li>El interés legítimo del responsable</li>
        </ul>
        <h3 id="-4-2-consentimiento-del-usuario-"><strong>4.2 Consentimiento del Usuario:</strong></h3>
        <ul>
          <li>El consentimiento se obtiene mediante la aceptación de nuestros términos y condiciones y esta política de privacidad  </li>
          <li>Los usuarios tienen la opción explícita de aceptar recibir marketing promocional al registrarse  </li>
          <li>El consentimiento puede ser revocado en cualquier momento</li>
        </ul>
        <h2 id="-5-transferencias-de-datos-y-terceros-"><strong>5. TRANSFERENCIAS DE DATOS Y TERCEROS</strong></h2>
        <p>No compartimos datos personales con terceros, excepto:</p>
        <ul>
          <li>magic.link, Web3Auth o Crossmint, que proporcionan infraestructura de clave pública  </li>
          <li>Proveedores de servicios necesarios para la operación de la plataforma  </li>
          <li>Autoridades competentes en los casos legalmente previstos</li>
        </ul>
        <p>Los usuarios deben aceptar los términos y condiciones de magic.link, Web3Auth o Crossmint para utilizar estos servicios.</p>
        <h2 id="-6-retenci-n-y-eliminaci-n-de-datos-"><strong>6. RETENCIÓN Y ELIMINACIÓN DE DATOS</strong></h2>
        <h3 id="-6-1-per-odo-de-retenci-n-"><strong>6.1 Período de retención:</strong></h3>
        <ul>
          <li>Las direcciones de correo electrónico se conservan mientras el usuario no solicite su eliminación  </li>
          <li>Los datos de las transacciones de blockchain son inherentemente permanentes debido a la naturaleza de la tecnología blockchain  </li>
          <li>Los demás datos se conservan por el tiempo necesario para cumplir con las finalidades descritas</li>
        </ul>
        <h2 id="-7-medidas-de-seguridad-"><strong>7. MEDIDAS DE SEGURIDAD</strong></h2>
        <p>ABS implementa robustas medidas de seguridad para proteger sus datos personales:</p>
        <h3 id="-7-1-medidas-t-cnicas-"><strong>7.1 Medidas técnicas:</strong></h3>
        <ul>
          <li>Auditorías de seguridad periódicas, tanto automatizadas como manuales  </li>
          <li>Realización de evaluaciones por expertos externos  </li>
          <li>Encriptación de datos tanto en reposo como en tránsito  </li>
          <li>Firewalls y sistemas de seguridad avanzados</li>
        </ul>
        <h3 id="-7-2-medidas-organizativas-"><strong>7.2 Medidas organizativas:</strong></h3>
        <ul>
          <li>Acceso restringido a datos personales  </li>
          <li>Políticas internas de protección de datos  </li>
          <li>Capacitación regular del personal en materia de privacidad</li>
        </ul>
        <h2 id="-8-derechos-arco-"><strong>8. DERECHOS ARCO</strong></h2>
        <p>Usted tiene derecho a:</p>
        <ul>
          <li><strong>Acceder</strong> a sus datos personales  </li>
          <li><strong>Rectificar</strong> sus datos cuando sean inexactos o incompletos  </li>
          <li><strong>Cancelar</strong> sus datos (considerar limitaciones con datos en blockchain)  </li>
          <li><strong>Oponerse</strong> al tratamiento de sus datos</li>
        </ul>
        <p>Para ejercer sus derechos ARCO, debe enviar una solicitud a [CORREO ELECTRÓNICO] incluyendo:</p>
        <ol>
          <li>Nombre completo  </li>
          <li>Documento que acredite su identidad  </li>
          <li>Descripción clara de los derechos que desea ejercer  </li>
          <li>Cualquier documento que facilite la localización de sus datos</li>
        </ol>
        <h2 id="-9-revocaci-n-del-consentimiento-"><strong>9. REVOCACIÓN DEL CONSENTIMIENTO</strong></h2>
        <p>Usted puede revocar el consentimiento para el tratamiento de sus datos personales en cualquier momento, siguiendo el mismo procedimiento establecido para el ejercicio de los derechos ARCO.</p>
        <h2 id="-10-uso-de-cookies-y-tecnolog-as-similares-"><strong>10. USO DE COOKIES Y TECNOLOGÍAS SIMILARES</strong></h2>
        <p>Nuestra plataforma utiliza cookies y tecnologías similares para:</p>
        <ul>
          <li>Mantener la sesión del usuario  </li>
          <li>Mejorar la experiencia de navegación  </li>
          <li>Personalizar contenido  </li>
          <li>Generar estadísticas</li>
        </ul>
        <p>Puede desactivar estas tecnologías en la configuración de su navegador.</p>
        <h2 id="-11-cambios-al-aviso-de-privacidad-"><strong>11. CAMBIOS AL AVISO DE PRIVACIDAD</strong></h2>
        <p>ABS se reserva el derecho de efectuar modificaciones o actualizaciones al presente Aviso de Privacidad. Cualquier modificación se comunicará a través de:</p>
        <ul>
          <li>Nuestra plataforma  </li>
          <li>Correo electrónico registrado  </li>
          <li>Avisos en el portal web</li>
        </ul>
        <h2 id="-12-contacto-"><strong>12. CONTACTO</strong></h2>
        <p>Para cualquier duda sobre este Aviso de Privacidad o el tratamiento de sus datos personales, puede contactarnos en:</p>
        <ul>
          <li>Formulario de contacto en <a href="https://avocadoblock.com" target="_blank" rel="noopener noreferrer">avocadoblock.com</a></li>
        </ul>
        <h2 id="-13-consentimiento-"><strong>13. CONSENTIMIENTO</strong></h2>
        <p>Al utilizar nuestros servicios y proporcionar sus datos personales, usted acepta los términos de este Aviso de Privacidad.</p>
      </LegalDocumentFormat>
      <CustomButton
        onClick={handleBack}
        style={{ margin: '0 auto' }}
        data-testid="button-back-home"
      >
        Regresar
      </CustomButton>
    </LegalDocumentLayout>

  )
}

export default PrivacyPolicyPage